// src/features/legacy-reports/components/LegacyTotalsCards.tsx

import { Paper, SimpleGrid, Skeleton, Text } from '@mantine/core';
import { LegacyReportsUtils } from '../LegacyReportsUtils';
import type { LegacyTotalsData } from '../types';

interface LegacyTotalsCardsProps {
  totals: LegacyTotalsData | null;
  isLoading: boolean;
}

interface CardProps {
  label: string;
  value: string | null;
  isLoading: boolean;
}

function TotalCard({ label, value, isLoading }: CardProps) {
  return (
    <Paper withBorder p="md">
      <Text size="xs" c="dimmed" tt="uppercase" fw={500}>
        {label}
      </Text>
      {isLoading ? (
        <Skeleton height={28} mt={6} width="60%" />
      ) : (
        <Text size="xl" fw={600} mt={2}>
          {value ?? '—'}
        </Text>
      )}
    </Paper>
  );
}

/**
 * Legacy display parity (operator-confirmed 2026-06-10): Views = cPlays,
 * Viewers = cUniques, watch time from cDuration in seconds. The
 * sViews/sUniques server-stats branch is dead legacy code — not ported.
 */
export function LegacyTotalsCards({ totals, isLoading }: LegacyTotalsCardsProps) {
  return (
    <SimpleGrid cols={{ base: 1, xs: 3 }} spacing="sm">
      <TotalCard
        label="Views"
        value={totals ? LegacyReportsUtils.formatCount(totals.cPlays) : null}
        isLoading={isLoading}
      />
      <TotalCard
        label="Viewers"
        value={totals ? LegacyReportsUtils.formatCount(totals.cUniques) : null}
        isLoading={isLoading}
      />
      <TotalCard
        label="Watch time"
        value={totals ? LegacyReportsUtils.formatWatchSeconds(totals.cDuration) : null}
        isLoading={isLoading}
      />
    </SimpleGrid>
  );
}
